import { createRouter, createWebHistory } from 'vue-router'
import { loadVueform } from '@/plugins/loadVueform'

// The form is the LCP content of the home page: start fetching Vueform together
// with the route chunk instead of waiting for the view to be evaluated.
const LohnrechnerView = () => {
  loadVueform()
  return import('@/views/LohnrechnerView.vue')
}
const LohnLetterView = () => import('@/views/LohnLetterView.vue')
const LohnLetterDetailView = () => import('@/views/LohnLetterDetailView.vue')
const FlatPageView = () => import('@/views/FlatPageView.vue')
const ResultView = () => import('@/views/ResultView.vue')
const FAQView = () => import('@/views/FAQView.vue')
const MappingTestView = () => import('@/views/MappingTestView.vue')
const SurveyResultView = () => import('@/views/SurveyResultView.vue')
const JobPageView = () => import('@/views/JobPageView.vue')
const JobPageListView = () => import('@/views/JobPageListView.vue')

const DE = document.documentElement.lang == 'de-ch'
const FR = document.documentElement.lang == 'fr-ch'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: LohnrechnerView
    },
    {
      path: '/result',
      name: 'result',
      component: ResultView
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQView
    },
    {
      path: DE ? '/lohnletter' : FR ? '/salaire-info' : '/lohnletter',
      name: 'lohnletter',
      component: LohnLetterView
    },
    {
      path: DE ? '/lohnletter/:slug' : FR ? '/salaire-info/:slug' : '/lohnletter/:slug',
      name: 'lohnletter-detail',
      props: true,
      component: LohnLetterDetailView
    },
    {
      path: '/test-mapping',
      name: 'test-mapping',
      component: MappingTestView
    },
    {
      path: '/pages/:slug',
      name: 'flat-page',
      props: true,
      component: FlatPageView
    },
    {
      path: DE ? '/berufe' : FR ? '/metiers' : '/lavori',
      name: 'job-list',
      component: JobPageListView
    },
    {
      path: DE ? '/beruf/:slug' : FR ? '/metier/:slug' : '/lavoro/:slug',
      name: 'job-page',
      props: true,
      component: JobPageView
    },
    {
      path: '/surveys/:uid',
      name: 'survey-result',
      props: true,
      component: SurveyResultView
    },
    {
      path: '/pages/lohn-architekt',
      redirect: () => {
        return {
          name: 'job-page',
          params: {
            slug: 'architekt-in'
          }
        }
      }
    },
    {
      path: '/pages/lohn-koch',
      redirect: () => {
        return {
          name: 'job-page',
          params: {
            slug: 'koch-koechin'
          }
        }
      }
    },
    {
      path: '/articles/details/154',
      redirect: () => {
        return {
          name: 'flat-page',
          params: {
            slug:
              document.documentElement.lang == 'de-ch'
                ? 'mindestlohne-in-der-schweiz'
                : document.documentElement.lang == 'fr-ch'
                  ? 'les-salaires-minimums-en-suisse'
                  : 'salari-minimi-in-svizzera'
          }
        }
      }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'home' }
    }
  ]
})

// Posthog is loaded lazily after the first navigation completes so it never
// blocks the critical JS evaluation path on initial page load.
let posthogInstance = null
async function getPosthogInstance() {
  if (!posthogInstance) {
    const { usePostHog } = await import('@/composables/usePosthog')
    posthogInstance = usePostHog().posthog
  }
  return posthogInstance
}

const ALLOWED_TRACKING_ROUTES = ['home', 'result']

router.afterEach((to) => {
  if (ALLOWED_TRACKING_ROUTES.includes(to.name)) {
    getPosthogInstance().then((posthog) => posthog.capture('$pageview'))
  }
})

router.beforeEach((to, from) => {
  if (from.path !== to.path && ALLOWED_TRACKING_ROUTES.includes(from.name)) {
    getPosthogInstance().then((posthog) => posthog.capture('$pageleave'))
  }
})

export default router
